export const parseTimepointToMinutes = (timepoint: string): number => {
  const match = timepoint
    .trim()
    .match(/^(-?\d+(?:\.\d+)?)\s*(min|mins|minute|minutes|hr|hrs|hour|hours)$/i);

  if (!match) {
    return Number.POSITIVE_INFINITY;
  }

  const value = Number.parseFloat(match[1]);
  const unit = match[2].toLowerCase();

  if (['hr', 'hrs', 'hour', 'hours'].includes(unit)) {
    return value * 60;
  }

  return value;
};
